import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getTemplates: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseTemplates`,
        isArray: true
    },
    saveTemplate: {
        method: 'POST',
        url: `${BASE_PATH_API}/leaseTemplates`
    },
    getTemplatesSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseTemplates/summary`
    },
    generatePreview: {
        method: 'POST',
        url: `${BASE_PATH_API}/leaseTemplates/preview`
    },
    previewTemplateById: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseTemplates/:id/preview`
    },
    getCustomTokens: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseTemplates/customTokens`
    },
    createCustomToken: {
        method: 'POST',
        url: `${BASE_PATH_API}/leaseTemplates/customTokens`
    },
    getAutoFillTokens: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseTemplates/tokens`
    },
    deleteLeaseTemplate: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leaseTemplates/:id`
    },
    copyTemplate: {
        method: 'POST',
        url: `${BASE_PATH_API}/leaseTemplates/:id/copy`
    },
    getTemplateById: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseTemplates/:id`
    },
    updateTemplate: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leaseTemplates/:id`
    },
    getPendingTokens: {
        method: 'POST',
        url: `${BASE_PATH_API}/leaseTemplates/templateTokens/:draftLeaseId`
    }
};

export function LeaseTemplatesApi() {
    const service = createActions(actions);
    
    service.downloadTemplates = function downloadTemplates() {
        return `${BASE_PATH_API}/v2/leaseTemplates/download`;
    };
    
    return service;
}
